import {requiredObject, requiredString} from "../../../utils/Validator";
import routes from "../../../consts/routes.json";

export const createJahresberichtSchema = () => {
    return {
        jahr: requiredObject(),
        von: requiredObject(),
        bis: requiredObject(),
        anlageBezeichnung: requiredString()
    };
};

export function calculateJahresberichtLink(jahresbericht, modus = "l") {
    const betriebId = jahresbericht?.anlage?.betrieb?.id;
    let pfad = `${routes.BETRIEBSAKTE_RAW}/${betriebId}`;

    const jahresberichtId = jahresbericht.id;
    return `${pfad}/jahresbericht/${jahresberichtId}/jahresberichtdaten?modus=${modus}`;
}